/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

export default stubFalse;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/isBuffer.js
// module id = 351
// module chunks = 0